// After a deploy, tabs opened before it still request the previous build's page files, which are gone - the server
// answers with index.html, so loading the page fails ("Loading chunk ... failed" / "Unexpected token '<'").
// Reload once to the target page to get the new build. Guarded so a real outage can't cause a reload loop
const CHUNK_ERROR = /Loading (CSS )?chunk|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed|Unexpected token '<'/

export const reloadOnChunkError = (error, path = window.location.href) => {
  if(!CHUNK_ERROR.test(`${error?.name || ''} ${error?.message || ''}`)) return
  const key = 'chunkReloadAt'
  try {
    const lastReload = Number(window.sessionStorage.getItem(key) || 0)
    if(Date.now() - lastReload < 30000) return // already reloaded a moment ago
    window.sessionStorage.setItem(key, String(Date.now()))
  } catch(e) {
    // sessionStorage unavailable (private mode) - still reload once below
  }
  window.location.assign(path)
}
